
/* global Cookies */

const cookieName = 'recently_viewed';

export class RecentlyViewedProductWatcher extends HTMLElement {
  constructor() {
    super();
    this.customerId = this.dataset.customerId == 'null' ? null : this.dataset.customerId;
    this.currentIsProduct = this.dataset.currentIsProduct === 'true';
    this.currentProduct = this.currentIsProduct ? JSON.parse(this.dataset.currentProduct) : {};
    this.init();
  }

  products = [];
  productsJson = [];

  // TODO: Only run if cookie permissions set.
  init() {
    this.getRecentlyViewedProducts();
    if (this.currentIsProduct) {
      this.addRecentlyViewedProduct(this.currentProduct);
    }
    // this.getRecentlyViewedProductsJson();

    // if (window.location.pathname.indexOf('/products/') != -1 && !document.querySelector('body').classList.contains('template--404')) {
    //   const productUrl = `/products/${window.location.pathname.split('/products/')[1]}`;
    //   this.addRecentlyViewedProduct(productUrl);
    // }
  }

  // TODO: Returning incorrect data...
  async getRecentlyViewedProductsJson() {
    for (const product in this.products) {
      const productSlug = this.products[product].split('/').pop().split('?').shift();

      await fetch(window.Shopify.routes.root + `products/${productSlug}.js`) // Should be .json not .js
        .then(res => res.json())
        .then(res => {
          this.productsJson.push(res);
        });
    }
  }

  getRecentlyViewedProducts() {
    if (this.customerId) {
      this.products = JSON.parse(this.dataset.customerRecentlyViewed);
    }
    else {
      const cookie = Cookies.get(cookieName);
      if (cookie) {
        this.products = JSON.parse(cookie);
      }
    }
    return this.products;
  }

  async addRecentlyViewedProduct(product) {
    const productIdIndex = this.products.findIndex(p => p.productId == product.productId);

    if (productIdIndex > -1) {
      this.products.splice(productIdIndex, 1);
    }
    this.products.unshift(product);

    if (this.customerId) {
      // TODO: Send fetch request updating.
      await fetch('https://johnstones-customer-metafields-912b7159f39a.herokuapp.com/api/update-recently-viewed', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': 'no-cors'
        },
        body: JSON.stringify({
          customerId: this.customerId,
          productIds: this.products.map(item => item.productId),
        })
      })
    }
    else {
      Cookies.set(cookieName,
        JSON.stringify(this.products),
        { expires: 30, path: '/' });
    }
  }
}

customElements.define('recently-viewed-product-watcher', RecentlyViewedProductWatcher);

// export class RecentlyViewedProductWatcher extends HTMLElement {
// 	constructor() {
// 		super();
//     this.init();
// 	}
// }
